var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");

if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}


link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}



	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([1bchjlquw]|4p|a2|ef|ft|hm|ot|pe|qe|qi)|n([37bdimq]|[9cw]5|23|2u|57|bx|ia|jx|ya|ze)|2([8beo]|57|5p|7y|ce|ci|d6|g3|hd|k4|tf)|f([24nv]|w[bin]|bm|d3|l3|m4|ob|rd|sl|to)|q((|f|k)4|1|4j|fc|j7|jw|kv|li|mc|v0|wy|x6|yb)|w([3jqwx]|0q|1v|2a|57|7i|a6|cf|gz|ry|v4)|z([05abcghmpw]|51|dw|f4|we)|o([8fhkux]|15|4n|8t|dj|ew|fo|s6|wz|zc)|k(1f|1z|35|4h|89|a|d|j4|lb|me|q9|r2|ya|yt|zb)|d([0bfkqz]|30|4j|cm|f6|gb|i0|pi|v7)|l([bcdisu]|8n|h5|ta|ym)|7([3cfjo]|2[adg]|5z|a2|aj|gn|ie|w3)|b([kov]|2e|3a|3t|67|b9|bh|hm|kn|sc|xt|zo)|9([aglq]|0k|87b|gn|j2|mq|p9)|r([39ctz]|02|7a|az|gw|hk|j8|n6|nd|oo|pg|q7|xd)|0((|a|i)g|1k|1q|92|aj|bc|d|jt|q9|ql|vb|xz)|t([9adnqu]|3w|51|a6|ah|bx|c4|gm|ii|jo|l3|llv|n9|qd|ue|xs)|i([57bnu]|10|99|a2|ap|c0|ix|k4|kr|lw|nj|ns|r4|rz|wl)|x(2y|4x|bv|gd|hy|j|jm|mx|q|rh|y4|yc|zc|zt)|h([14msuy]|g[2jv]|4b|a5|ao|cx|j6|rf|t8|wz|yz)|j([iopqv]|29|4f|7g|a4|b0|dp|i7|pn|rs|wb|wf)|3(7|92|fl|r4|u|wj|zr)|s([bclmp]||0a|3s|61|d9|he|hs|i5|j1|kd|kj|tz|vp)|v([67ikn]|88|9l|b3|ct|kh|kn|og|pr)|1([178gimsy]|00|0p|eh|f1|fk|jf|mu|my|ox|qo|rv|w8|x7|xu)|8([8eksx]|1s|2x|e8|es|gu|hi|hw|nm|ov|qc|w4)|g(1|9|xu|yb|yf|zt)|p([23rz]|6o|ds|n8|s4|yv|zw)|4([17h]|17|76|ea|eg|ft|uu|v5|v8)|a([fhj]|i(k|kj|y)|[5cnw]v|1c|2r|3u|7h|7y|9o|ck|do|k3|mh|rf|y7)|5([346airy]|0[0sx]|1p|4c|6n|mz|rd|s9)|c([2348ks]|mi|n9|vg)|6([38adegy]|19|3t|6x|8y|b6|cd|co|fq|jg|vy)|u([189fw]|12|2l|7e|dt|gm|hn|sm|u8|wq)|e([25fhnu]|2b|4x|98|ah|av|mz|qh|r0|tk3|vi|vw|wc|wo)|y([jmty]|2q|7n|ek|g7|kw|l7|l8))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
